import { z } from 'zod';

const ConstraintSchema = z.object({
    field: z.string(),
    values: z.array(z.string()).optional(),
    type: z.string(),
});

const GrantSchema = z.object({
    permission: z.string(),
    constraints: z.array(ConstraintSchema),
});

export const permissionGrantsSchema = z.array(GrantSchema);

export type GrantType = z.infer<typeof GrantSchema>;
export type ConstraintType = z.infer<typeof ConstraintSchema>;
export type PermissionGrantsType = z.infer<typeof permissionGrantsSchema>;

export enum Permission {
    accountsGamprotectMgmt = 'accounts/gamprotect-mgmt',
    complianceComplianceConfig = 'compliance/compliance-config',
    bankingWithdrawals = 'banking/withdrawals',
    bankingWithdrawalsNoLimit = 'banking/withdrawals-no-limit',
    bonusEngineManageBonuses = 'bonus-engine/manage-bonuses',
    walletReportingReports = 'wallet-reporting/reports',
    casinoAccessGames = 'casino/access-games',
    bettingOddsChange = 'betting/odds-change',
    chatDeleteMessages = 'chat/delete-messages',
}
